import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ReturnShippedErrorModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal show={show} onClose={onClose} title={t('Devolución enviada')} size="m">
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'Parece que tu otra devolución ya ha sido enviada, por lo que necesitarás una nueva etiqueta de devolución para esta nueva solicitud'
          )}
        </Text>
        <Button onClick={onClose}>{t('Entendido')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default ReturnShippedErrorModal
